import arrowRight from '@/assets/icons/arrow-right.svg';
import './PlanCategory.scss';

interface TagLink {
  label: string;
  href: string;
}

export interface PlanCategoryProps {
  title?: string;
  cta?: string;
  href?: string;
  tags?: TagLink[];
  image?: string;
  className?: string;
}

const DEFAULTS = {
  mobile: {
    title: 'Forfaits Mobile',
    cta: 'Comparer tous les<br> Forfaits Mobile',
    href: '/forfaits-mobiles-comparateur/',
  },
  internet: {
    title: 'Box Internet',
    cta: 'Comparer toutes les<br> Box Internet',
    href: '/comparateur/',
  },
};

export function PlanCategory({
  title = DEFAULTS.mobile.title,
  cta = DEFAULTS.mobile.cta,
  href = DEFAULTS.mobile.href,
  tags = [],
  image,
  className,
}: PlanCategoryProps) {
  return (
    <div className={`plan-category${className ? ` ${className}` : ''}`}>
      <h3 className="plan-category__title">
        <span className="plan-category__title-prefix">Les </span>
        {title}
      </h3>
      <a
        href={href}
        className="plan-category__card"
        aria-label={cta.replace(/<br\s*\/?>/g, ' ')}
      >
        {image && (
          <img
            className="plan-category__card-bg"
            src={image}
            alt=""
            aria-hidden="true"
            loading="lazy"
            width={1200}
            height={800}
          />
        )}
        <span className="plan-category__arrow">
          <img src={arrowRight} alt="" aria-hidden="true" width={20} height={20} />
        </span>
        <span className="plan-category__cta" dangerouslySetInnerHTML={{ __html: cta }} />
      </a>
      <div className="plan-category__tags">
        {tags.map((tag) => (
          <a key={tag.label} href={tag.href} className="plan-category__tag">
            {tag.label}
          </a>
        ))}
      </div>
    </div>
  );
}

export default PlanCategory;
